import {
    Card, CardContent, CardHeader, Grid,
    TextField, Button, Collapse, Breadcrumbs, Link
} from '@mui/material'
import { Alert, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import FolderCopyTwoToneIcon from '@mui/icons-material/FolderCopyTwoTone';
import jwt_decode from "jwt-decode";

export default function PartidaForma() {
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [partida, setPartida] = useState({
        clave: '',
        concepto: ''
    })

    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState(false)
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')

    const navigate = useNavigate()

    const params = useParams()



    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        if (editing) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas/${params.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(partida)
            })
            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize

            if (data.message) {
                setOpen(true)
                data.message === "llave duplicada viola restricción de unicidad «partidas_clave_key»" ?
                    setMensaje(`La clave ya existe`) : (data.message === "llave duplicada viola restricción de unicidad «partidas_concepto_key»" ?
                        setMensaje(`El concepto ya existe`) : setMensaje(`${data.message}`))
                setLoading(false)
                return
            }
            else {
                setOpen(false)
            }

        }
        else {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas`, {
                method: "POST",
                body: JSON.stringify(partida),
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
            })

            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')

            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize

            if (data.message) {
                setOpen(true)

                data.message === "llave duplicada viola restricción de unicidad «partidas_clave_key»" ?
                    setMensaje(`La clave ya existe`) : (data.message === "llave duplicada viola restricción de unicidad «partidas_concepto_key»" ?
                        setMensaje(`El concepto ya existe`) : setMensaje(`${data.message}`))
                setLoading(false)
                return
            }
            else {
                setOpen(false)
            }
        }
        setLoading(false)

        navigate('/partidas')
    }

    const cargarPartida = async (id) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas/${id}`)
        const data = await res.json()
        setPartida({ clave: data.clave, concepto: data.concepto })
        setEditing(true) //Estado
    }

    useEffect(() => {
        (async () => {
            if (params.id) {
                await cargarPartida(params.id)
            }
        })();
    }, [params.id]
    )

    const handleChange = e => {
        setPartida({ ...partida, [e.target.name]: e.target.value })
        //copio todo lo que tenga la tarea y luego actualizo lo que se está tecleando
    }
    return (
        <>
        {
            <div role="presentation" style={{marginTop:'20px'}} >
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              sx={{ display: 'flex', alignItems: 'center' }}
              color="inherit"
              href={`/proyectosInforme/${idResponsable}/true`}
            >
              <FolderCopyTwoToneIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Informe
            </Link>
            <Link
              underline="hover"
              sx={{ display: 'flex', alignItems: 'center' }}
              color="inherit"
              href="javascript:void(0)" onClick={()=>{navigate(-1)}}
            >
              <KeyboardReturnIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Regresar
            </Link>       
          </Breadcrumbs>
        </div>}
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
        <Grid item xs={12} sm={4}>

        <Card>
            <CardHeader title={editing ? 'Editar Partida' : 'Agregar Nueva Partida'}></CardHeader>
            <CardContent>
                <form onSubmit={handleSubmit}>
                <Grid container direction='row' justifyContent='center' spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField label='Escriba la clave' name='clave' onChange={handleChange} value={partida.clave} sx={{width: '100%'}}/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField label='Escriba el concepto' name='concepto' multiline minRows='5' onChange={handleChange} value={partida.concepto}  sx={{width: '100%'}}/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={!partida.clave || !partida.concepto || loading}>
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                <Box sx={{ width: '100%' }}>
                    <Collapse in={open}>
                        <Alert severity={severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            style={{ marginTop: 30 }}
                        >
                            {mensaje}
                        </Alert>
                    </Collapse>
                </Box>
            </CardContent>
        </Card>
        </Grid>
        </Grid>
        </>
    )
}